module.exports = "pegasus_template/assets/test-fixture-car-back.jpg";